import { SystemParameterCreateReduxState, SystemParameterReducerDispatch, SystemParameterReduxState, SystemParameterReduxTypes , SystemParameterListUiState } from "./types";

const LIST_INIT_STATE: SystemParameterReduxState = {
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: { self: null, first: null, previous: null, next: null, last: null }
    },
    records: []
  },
  loading: false,
  error: null
};

const ITEM_INIT_STATE: SystemParameterCreateReduxState = {
  data: {},
  loading: false,
  error: null
};

const SystemParameterListReducer = (state: SystemParameterReduxState = LIST_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS:
      return { ...state, loading: true };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...LIST_INIT_STATE };
    default:
      return { ...state };
  }
};

const SystemParameterReducer = (state: SystemParameterCreateReduxState = ITEM_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID:
      return { ...state, loading: true };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...ITEM_INIT_STATE };
    default:
      return { ...state };
  }
};

const UpdateSystemParameterReducer = (state: SystemParameterCreateReduxState = ITEM_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER:
      return { ...state, loading: true };
    case SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...ITEM_INIT_STATE };
    default:
      return { ...state };
  }
};

const SystemParameterVersionDetailsReducer = (state: SystemParameterCreateReduxState = ITEM_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS:
      return { ...state, loading: true };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...ITEM_INIT_STATE };
    default:
      return { ...state };
  }
};

const SystemParameterListVersionReducer = (state: SystemParameterReduxState = LIST_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...LIST_INIT_STATE };
    default:
      return { ...state };
  }
};

const SystemParameterLatestVersionReducer = (state: SystemParameterCreateReduxState = ITEM_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION:
      return { ...state, loading: true };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...ITEM_INIT_STATE };
    default:
      return { ...state };
  }
};

const ApproveSystemParameterReducer = (state: SystemParameterCreateReduxState = ITEM_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER:
      return { ...state, loading: true };
    case SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...ITEM_INIT_STATE };
    default:
      return { ...state };
  }
};

const RejectSystemParameterReducer = (state: SystemParameterCreateReduxState = ITEM_INIT_STATE, action: SystemParameterReducerDispatch) => {
  switch (action.type) {
    case SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER:
      return { ...state, loading: true };
    case SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case SystemParameterReduxTypes.RESET:
      return { ...ITEM_INIT_STATE };
    default:
      return { ...state };
  }
};


const SYSTEM_PARAMETER_LIST_UI_INIT_STATE: SystemParameterListUiState = {
  currentPage: 1,
  searchFilter: {},
  sort: { field: "updatedOn", order: false },
  isFilterApplied: false
};

/** List UI state — intentionally ignores entity RESET so filters survive route changes */
const SystemParameterListUiReducer = (
  state: SystemParameterListUiState = SYSTEM_PARAMETER_LIST_UI_INIT_STATE,
  action: { type: string; payload?: Partial<SystemParameterListUiState> }
) => {
  switch (action.type) {
    case SystemParameterReduxTypes.SET_SYSTEM_PARAMETER_LIST_UI:
      return {
        ...state,
        ...action.payload
      };
    case SystemParameterReduxTypes.RESET_SYSTEM_PARAMETER_LIST_UI:
      return { ...SYSTEM_PARAMETER_LIST_UI_INIT_STATE };
    default:
      return state;
  }
};

export {
  SystemParameterListUiReducer,
  SystemParameterListReducer,
  SystemParameterReducer,
  UpdateSystemParameterReducer,
  SystemParameterListVersionReducer,
  SystemParameterVersionDetailsReducer,
  SystemParameterLatestVersionReducer,
  ApproveSystemParameterReducer,
  RejectSystemParameterReducer
};
